import { Injectable } from '@angular/core';

import { AuthTokenConstants } from '../../constants/auth-constants';
import { CoBrowsingCompany } from '../../models/cobrowsing-company.model';

@Injectable({ providedIn: 'root' })
export class CoBrowsingCompanyService {
  private readonly authTokenConstants = AuthTokenConstants;

  setCobrowsingCompany(company: CoBrowsingCompany | null): void {
    localStorage.setItem(
      this.authTokenConstants.COBROWSING_COMPANY,
      JSON.stringify(company),
    );
  }

  getCobrowsingCompany(): CoBrowsingCompany | null {
    const data = localStorage.getItem(
      this.authTokenConstants.COBROWSING_COMPANY,
    );

    return data ? JSON.parse(data) : null;
  }

  clearCobrowsingCompany(): void {
    localStorage.removeItem(this.authTokenConstants.COBROWSING_COMPANY);
  }
}
